import { useState } from 'react'
import ArgomentiService from '../services/ArgomentiService/ArgomentiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useArgomenti = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingArgomenti: false,
    isLoadingArgomentiByParams: false,
    isLoadingArgomentoCreating: false,
    isLoadingArgomentoUpdate: false,
    isLoadingArgomentoDelete: false
  });

  const [modalState, setModalState] = useState({
    showModalCreateArgomento: false,
    showModalUpdateArgomento: false
  });

  const getArgomentiByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingArgomentiByParams: true });
    try {
      let obj;
      let response = await ArgomentiService.getArgomentiByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingArgomentiByParams: false });
    }
  }

  const createArgomento = async (data) => {
    setLoadingState({ ...loadingState, isLoadingArgomentoCreating: true });
    try {
      const response = await ArgomentiService.createArgomento(data);
      alertService.success("Argomento creato con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateArgomento: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingArgomentoCreating: false });
    }
  }

  const updateArgomento = async (data) => {
    setLoadingState({ ...loadingState, isLoadingArgomentoUpdate: true });
    try {
      const response = await ArgomentiService.updateArgomento(data);
      alertService.success("Argomento aggiornato con successo", {autoClose: true});
      setModalState({...modalState, showModalUpdateArgomento: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingArgomentoUpdate: false });
    }
  }

  const deleteArgomento = async (id) => {
    setLoadingState({ ...loadingState, isLoadingArgomentoDelete: true });
    try {
      await ArgomentiService.deleteArgomento(id);
      alertService.success("Argomento eliminato con successo", {autoClose: true});
      return true;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingArgomentoDelete: false });
    }
  }

  const getArgomentiByCorso = async (idCorso, params) => {
    setLoadingState(prev => ({ ...prev, isLoadingArgomenti: true }));
    try {
      const response = await ArgomentiService.getArgomentiByCorso(idCorso, params);
      return response;
    } catch (err) {
      handleError(err);
      return { data: [], count: 0 };
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingArgomenti: false }));
    }
  }

  return {
    loadingStateArgomenti: loadingState,
    modalStateArgomenti: modalState,
    setModalStateArgomenti: setModalState,
    getArgomentiByParams,
    createArgomento,
    updateArgomento,
    deleteArgomento,
    getArgomentiByCorso
  };      
}

export default useArgomenti;